import React, { LegacyRef } from 'react';
import cn from 'classnames';

import { ILinkActionInterface } from '../interfaces';

import { ELinkMenuPlacement } from './enum';
import { TLinkMenuPlacement } from './type';

import styles from './LinkMenu.module.scss';

interface ILinkActionListProps {
	actions: Array<ILinkActionInterface>;
	menuRef: LegacyRef<HTMLDivElement>;
	selectHandler?: () => void;
	menuPlacement?: TLinkMenuPlacement;
}

const LinkActionList = ({
	actions,
	menuRef,
	selectHandler,
	menuPlacement = ELinkMenuPlacement.bottomStart,
}: ILinkActionListProps) => (
	<div
		ref={menuRef}
		className={cn(styles.linkMenuContainer, styles[menuPlacement])}
	>
		{actions.map((actionItem) => {
			const clickHandler = () => {
				actionItem.action();
				selectHandler?.();
			};

			return (
				actionItem.name && actionItem.label && (
					<div
						key={`link_action_${actionItem.name}`}
						className={styles.linkItem}
					>
						<div
							key={actionItem.name}
							className={styles.actionItem}
							data-testid='link-action-item'
							onClick={clickHandler}
						>
							{actionItem.label}
						</div>
					</div>
				)
			);
		})}
	</div>
);

export default LinkActionList;
